import dayjs from "dayjs";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportNovosNegociosUseCase } from "../../../presentation/useCases/read/get_report_novos_negocios_use_case";

/**
 * GetReportNovosNegociosUseCase
 */

export class GetReportNovosNegociosUseCase implements IGetReportNovosNegociosUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(idNovosNegocios: number, requiredMimeType: ReportMimeType | null): Promise<ReportData> {
    const response = await this.repository.getReportNovosNegocios(idNovosNegocios, requiredMimeType ?? "text/html");

    if (response.mimeType !== "text/html") {
      const arquivoData = response.bytes;
      const arquivoNome = idNovosNegocios === null
        ? `novos_negocios_lista_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`
        : `novo_negocio_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;

  }
}
